import i18n from 'widget/i18n/index';

export const standardFieldKeys = {
  emailAddress: {
    key: 'EMAIL_ADDRESS',
  },
  fullName: {
    key: 'FULL_NAME',
  },
  phoneNumber: {
    key: 'PHONE_NUMBER',
  },
};

const getSelectedLocale = () => {
  if (typeof window === 'undefined') return 'en';
  return window.chatwootConfig?.selectedLocale || 'en';
};

const getTranslations = locale => {
  const language = locale?.split('_')[0];
  return i18n[locale] || i18n[language] || i18n.en;
};

const getStandardFieldTranslation = ({ key, locale }) => {
  const translationKey = standardFieldKeys[key]?.key || key;
  return getTranslations(locale).PRE_CHAT_FORM.FIELDS[translationKey];
};

export const getLabel = ({ key, label, locale = getSelectedLocale() }) => {
  return getStandardFieldTranslation({ key, locale })?.LABEL || label;
};
export const getPlaceHolder = ({
  key,
  placeholder,
  locale = getSelectedLocale(),
}) => {
  return (
    getStandardFieldTranslation({ key, locale })?.PLACEHOLDER || placeholder
  );
};

export const getCustomFields = ({ standardFields, customAttributes }) => {
  let customFields = [];
  const { pre_chat_fields: preChatFields } = standardFields;
  customAttributes.forEach(attribute => {
    const itemExist = preChatFields.find(
      item => item.name === attribute.attribute_key
    );
    if (!itemExist) {
      customFields.push({
        label: attribute.attribute_display_name,
        placeholder: attribute.attribute_display_name,
        name: attribute.attribute_key,
        type: attribute.attribute_display_type,
        values: attribute.attribute_values,
        field_type: attribute.attribute_model,
        regex_pattern: attribute.regex_pattern,
        regex_cue: attribute.regex_cue,
        required: false,
        enabled: false,
      });
    }
  });
  return customFields;
};

export const getFormattedPreChatFields = ({
  preChatFields,
  locale = getSelectedLocale(),
}) => {
  return preChatFields.map(item => {
    return {
      ...item,
      label: getLabel({
        key: item.name,
        label: item.label ? item.label : item.name,
        locale,
      }),
      placeholder: getPlaceHolder({
        key: item.name,
        placeholder: item.placeholder ? item.placeholder : item.name,
        locale,
      }),
    };
  });
};

export const getPreChatFields = ({
  preChatFormOptions = {},
  customAttributes = [],
  locale = getSelectedLocale(),
}) => {
  const { pre_chat_message, pre_chat_fields } = preChatFormOptions;
  let customFields = {};
  let preChatFields = {};

  const formattedPreChatFields = getFormattedPreChatFields({
    preChatFields: pre_chat_fields,
    locale,
  });

  customFields = getCustomFields({
    standardFields: { pre_chat_fields: formattedPreChatFields },
    customAttributes,
  });
  preChatFields = [...formattedPreChatFields, ...customFields];

  return {
    pre_chat_message,
    pre_chat_fields: preChatFields,
  };
};
